import React from 'react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { testFirebaseConnection } from '../utils/firebaseTest';

export default function FirebaseTest() {
  const [status, setStatus] = React.useState<{
    success?: boolean;
    message?: string;
    loading?: boolean;
  }>({ loading: true });

  React.useEffect(() => {
    let mounted = true;

    const testConnection = async () => {
      try {
        const result = await testFirebaseConnection();
        if (mounted) {
          setStatus(result);
        }
      } catch (error) {
        if (mounted) {
          setStatus({ 
            success: false, 
            message: error instanceof Error ? error.message : 'An error occurred',
            loading: false
          });
        }
      }
    };

    testConnection();

    return () => {
      mounted = false;
    };
  }, []);

  if (status.loading) {
    return (
      <div className="flex items-center justify-center p-4">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className={`rounded-lg p-4 flex items-center ${
        status.success ? 'bg-green-50' : 'bg-red-50'
      }`}>
        {status.success ? (
          <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
        ) : (
          <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
        )}
        <span className={status.success ? 'text-green-700' : 'text-red-700'}>
          {status.message}
        </span>
      </div>
    </div>
  );
}